const money = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const removeManualOrderDiscount = (pricing = {}, fallbackTotal = 0) => {
  const previous = Number(pricing.manualDiscount?.amount || 0);
  const finalTotal = money(Number(pricing.finalTotal ?? fallbackTotal) + previous);
  const result = {
    ...pricing,
    listTotal: money(pricing.listTotal ?? finalTotal),
    finalTotal,
    totalDiscount: money(Math.max(0, Number(pricing.totalDiscount || 0) - previous)),
    adjustments: (pricing.adjustments || []).filter((item) => item.type !== "manual_discount"),
  };
  delete result.manualDiscount;
  delete result.paymentPrices;
  return result;
};

// Edit replaces the previous discount; it never discounts the discounted total again.
export const previewOrderDiscount = (order, { type = "none", value = 0 } = {}) => {
  const amount = Number(value);
  if (!["none", "fixed", "percent"].includes(type) || !Number.isFinite(amount) || amount < 0) {
    throw new Error("Ingresa un descuento valido.");
  }
  if (type !== "none" && amount <= 0) throw new Error("El descuento debe ser mayor a cero.");
  if (type === "percent" && amount > 100) throw new Error("El porcentaje no puede superar el 100%.");
  const current = order?.pricing || {};
  const apply = (quote) => {
    const base = removeManualOrderDiscount(quote, order?.totalAmount);
    if (!Number.isFinite(base.finalTotal) || base.finalTotal < 0) throw new Error("La cuenta no tiene un total valido.");
    if (type === "none") return base;
    if (type === "fixed" && amount > base.finalTotal) throw new Error("El descuento no puede superar el total de la cuenta, incluido su precio en efectivo.");
    const discount = money(type === "percent" ? base.finalTotal * amount / 100 : amount);
    return {
      ...base,
      finalTotal: money(base.finalTotal - discount),
      totalDiscount: money(base.totalDiscount + discount),
      manualDiscount: { type, value: amount, amount: discount, baseTotal: base.finalTotal },
      adjustments: [...base.adjustments, {
        id: "owner-discount", type: "manual_discount", title: "Descuento del local",
        summary: type === "percent" ? `${amount}% adicional` : "Descuento en pesos", amount: discount,
      }],
    };
  };
  const paymentPrices = {
    cash: apply(current.paymentPrices?.cash || current),
    other: apply(current.paymentPrices?.other || current),
  };
  const paymentBasis = current.paymentBasis === "other" ? "other" : "cash";
  return { ...current, ...paymentPrices[paymentBasis], paymentBasis, paymentPrices,
    manualDiscount: paymentPrices[paymentBasis].manualDiscount || null };
};

export const getOrderDiscountBlockReason = (order, paymentState = {}) => {
  if (paymentState.isPaid || order?.paidAt || order?.cashCollectedAt ||
      ["paid", "approved", "accredited", "settled", "completed", "closed"].includes(order?.paymentStatus)) {
    return "La cuenta ya esta pagada. No se puede modificar su descuento.";
  }
  if (["closed", "cancelled", "canceled"].includes(order?.phase)) return "La cuenta ya esta cerrada.";
  if (order?.source === "external" || order?.externalOrderId) return "Esta cuenta se gestiona desde Pedidos externos.";
  if (paymentState.hasPendingDigitalPayment || order?.pendingPaymentIntentId ||
      order?.pendingDigitalPaymentIntentId || order?.paymentStatus === "payment_in_progress") {
    return "Hay un cobro digital en curso. Cancelalo antes de cambiar el importe.";
  }
  return "";
};
